import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AdminDataService } from "src/app/_services/admin.data.service";
import { AuthenticationService } from "src/app/_services/authenticationService";
import { DialogServiceService } from "../dialog-service.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-impersonate-dialog",
    templateUrl: "./impersonate-dialog.component.html",
    styleUrls: ["./impersonate-dialog.component.scss"],
})
export class ImpersonateDialogComponent implements OnInit {
    @Input() title;
    @Input() message;
    constructor(
        public activeModal: NgbActiveModal,
        private adminService: AdminDataService,
        private authService: AuthenticationService,
        private dialogService: DialogServiceService
    ) {}

    ngOnInit(): void {}

    impersonate() {
        ///localStorage.clear();
        console.log("Trying to impersonate here");
        const userData = this.authService.currentUserData;
        const vendorCode = this.adminService.getImpersonateVendorCode();
        console.log(vendorCode);
        console.log(userData.loginData.user.eippSession);

        const reqData = {
            supplierCode: vendorCode,
            session: userData.loginData.user.eippSession,
            sellerCode: userData.userData.sellerCode,
        };

        localStorage.setItem("sellerCode", vendorCode);

        this.activeModal.close(false);
        this.dialogService.showWaitDialog();
        console.log(reqData);

        this.adminService.adminImpersonate(reqData).subscribe((data) => {
            if (data.success) {
                if (!data.data?.user?.enforcePasswordChange) {
                    const vendorBase = String(
                        environment.vendorUrl || ""
                    ).trim();
                    window.location.href =
                        `${vendorBase}#/manage-user?token=` +
                        userData.loginData.user.eippSession.sessionId +
                        "$$$" +
                        vendorCode +
                        "$$$" +
                        userData.userName +
                        "$$$" +
                        userData.loginUsername +
                        "$$$" +
                        userData.userData.sellerCode;
                } else {
                    console.log("user hasn't onboarded");
                }
            } else {
                this.dialogService.hideWaitDialog();
                this.dialogService.showInfoDialog("", data.msg);
                console.log(data);
            }
        });

        //console.log(reqData);
    }
}
